import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/topic/book"

const topicBook = {
  topicBookListPage(pageSize, limit, versionId, keyWord) {
    return axios.get(pre + `/topicBookListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          versionId: versionId,
          keyWord: keyWord
        }
    });
  },
  topicBookInfo(id) {
    return axios.get(pre + `/topicBookInfo`, {params: {id: id}});
  },
  topicBookSave(params) {
    return axios.post(pre + `/topicBookSave`, qs.stringify(params));
  },
  topicBookDelete(id) {
    return axios.delete(pre + `/topicBookDelete`, {params: {id: id}});
  },
}
export default topicBook;



// WEBPACK FOOTER //
// ./src/api/topic/topicBook.js